import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

class SelectPlantillasEvaluacionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: "",
    };

    this.buscarPlantillas = debounce(this.buscarPlantillas.bind(this), 300);
    // Contador de secuencia para descartar respuestas que llegan fuera de orden
    this.requestSeq = 0;
  }

  componentDidMount() {
    this.buscarPlantillas("", true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tipoProveedorId !== this.props.tipoProveedorId) {
      this.buscarPlantillas("", true);
      return;
    }
    // En modo múltiple "value" es un arreglo de ids, no texto de búsqueda
    if (this.props.mode === "multiple" || this.props.mode === "tags") return;
    if (prevProps.value !== this.props.value) {
      this.buscarPlantillas(this.props.value || "", true);
    }
  }

  async buscarPlantillas(texto, inicial, append = false) {
    const seq = ++this.requestSeq;
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "plantillasEvaluacion/selectPlantillasItem",
        {
          query: append ? this.state.texto || texto || this.props.value : texto || "",
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
          tipoProveedorId: this.props.tipoProveedorId,
        },
        { headers: this.props.headersToken },
      );

      // Descartar respuesta obsoleta
      if (seq !== this.requestSeq) return;

      if (res.data.success === 2) {
        this.setState((prev) => ({
          opciones: append
            ? [...prev.opciones, ...res.data.plantillas]
            : res.data.plantillas,
          primerCarga: false,
          texto: append ? this.state.texto : texto,
        }));
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      if (seq !== this.requestSeq) return;
      console.error("Error al buscar plantillas de evaluación:", error);
      this.setState({ opciones: [] });
    } finally {
      if (seq !== this.requestSeq) return;
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }

  render() {
    const { disabled, width, style, placeholder, ...restProps } = this.props;

    return (
      <Select
        showSearch
        filterOption={false}
        onSearch={this.buscarPlantillas}
        disabled={disabled}
        loading={this.state.cargando}
        notFoundContent={
          this.state.cargando ? (
            <Spin size="small" />
          ) : this.state.primerCarga ? (
            "Cargando..."
          ) : (
            "No se encontraron plantillas autorizadas"
          )
        }
        placeholder={placeholder ?? "Selecciona una plantilla"}
        style={{ width: width || "100%", ...style }}
        {...restProps}
        onChange={(value) => {
          const plantilla = Array.isArray(value)
            ? this.state.opciones.filter((p) => value.includes(p._id))
            : this.state.opciones.find((p) => p._id === value);
          if (this.props.onChange) this.props.onChange(value, plantilla);
        }}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarPlantillas(this.props.value || "", false, true);
          }
        }}
      >
        {this.state.opciones.map((plantilla) => (
          <Option key={plantilla._id} value={plantilla._id}>
            {plantilla.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectPlantillasEvaluacionItem;
